import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

export interface ICellRendererParamsForCostCenter extends ICellRendererParams {
    editMode: () => boolean;
}

@Component({
    selector: 'Renderer-cell',
    template: `
        @if (params && params.data && !params.data.isTotal) {
          <team-picker [editMode]="params.editMode()" [useCostCenter]="true" [(costCenterTeamId)]="params.data.costCenterTeamId" [(costCenter)]="params.data.costCenter"></team-picker>
        }
        `,
    standalone: false
})
export class AgGridCostCenterCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForCostCenter;

    agInit(params: ICellRendererParamsForCostCenter): void {
        this.params = params;
    }

    refresh() {
        return false;
    }
}
